export const hasWorkingDay = (outlet) =>
  outlet.monday ||
  outlet.tuesday ||
  outlet.wednesday ||
  outlet.thursday ||
  outlet.friday ||
  outlet.saturday ||
  outlet.sunday;
